import { render, staticRenderFns } from "./GraphDetail46.vue?vue&type=template&id=2681dc5c&scoped=true"
import script from "./GraphDetail46.vue?vue&type=script&lang=js"
export * from "./GraphDetail46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681dc5c",
  null
  
)

export default component.exports